module.exports = __webpack_public_path__ + "media/Chapter4VoiceOver.5bd6a43f.mp3";